import { useEffect } from 'react';
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from 'react-router-dom';
import * as Sentry from '@sentry/react';

const dsn = process.env.REACT_APP_SENTRY_DSN;
const hasDsn = Boolean(dsn);

const integrations = [
  Sentry.reactRouterV6BrowserTracingIntegration({
    useEffect,
    useLocation,
    useNavigationType,
    createRoutesFromChildren,
    matchRoutes,
  }),
];

if (hasDsn) {
  integrations.push(
    Sentry.replayIntegration({
      maskAllText: true,
      blockAllMedia: true,
    }),
  );
}

Sentry.init({
  dsn: dsn || undefined,
  enabled: hasDsn,
  environment: process.env.REACT_APP_SENTRY_ENVIRONMENT || process.env.NODE_ENV,
  integrations,
  tracesSampleRate: process.env.NODE_ENV === 'production' ? 0.2 : 1.0,
  replaysSessionSampleRate: hasDsn && process.env.NODE_ENV === 'production' ? 0.05 : 0,
  replaysOnErrorSampleRate: hasDsn ? 1.0 : 0,
});
